import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=25c83274&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c83274')) {
      api.createRecord('25c83274', component.options)
    } else {
      api.reload('25c83274', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=25c83274&", function () {
      api.rerender('25c83274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-87hldBkOpOkAk/JS/offershelp.vue"
export default component.exports